module.exports = __webpack_public_path__ + "static/07-a832a7c142a25c1fb654c92e87c80b89.jpg";